import React from 'react';
import Spinner from '@lsq/nextgen/v2/spinner';
import './index.css';

function LsqProgressSpinner() {
  return <Spinner size="md" customStyleClass="lsq-progress" data-testid="progress-spinner" />;
}

export default LsqProgressSpinner;
